<template>
  <el-card>
    <div style="text-align: left">
          <span style="margin-left: 5px; height:16px;width:10px;background:#38e8eb; display: inline-block"> </span>
          <span style="font-size:18px;  font-weight:700">通知公告</span>
    </div>
    <el-input v-model="searchFactor.theme" :border="false"  style="width:85%; font-size: 35px; font-weight: bold ;  margin-top: 20px;"  ></el-input>
    <el-button type="primary" class="el-icon-finished" @click="createNotice">提交编辑</el-button>
    <el-divider ></el-divider>
    <div style="border: 1px solid #ccc;">
      <Toolbar
        style="border-bottom: 1px solid #ccc"
        :editor="wangEditor.editor"
        :defaultConfig="wangEditor.toolbarConfig"
        :mode="wangEditor.mode"/>
      <Editor
        style="height: calc(100vh - 250px); overflow-y: hidden;"
        v-model="wangEditor.html"
        :defaultConfig="wangEditor.editorConfig"
        :mode="wangEditor.mode"
        @onCreated="onCreated"/>
    </div>
  </el-card>
</template>                     
<script>
// 引入组
import '@wangeditor/editor/dist/css/style.css'
import axios from  '@/api/axiosConfig'
import {getToken} from  '@/api/utils'
import {Editor, Toolbar } from '@wangeditor/editor-for-vue'
import {MESSAGE_DURATION,fileAreaType} from  '@/api/constant'
import SERVICE_URL  from  '@/api/url'
export default {
  name : 'pc_ctr_notice_edit',
  data() {
    return {
      searchFactor : {
        theme : "",
        id :''
      },
      wangEditor: {
        editor: null,
        html: '<p>hello</p>',
        toolbarConfig: { excludeKeys: ['group-video'] },
        editorConfig: { 
          MENU_CONF:{
            uploadImage:{
            server: '',
            fieldName: 'file',
            // 单个文件的最大体积限制，默认为 2M
            maxFileSize: 10 * 1024 * 1024, // 1M
            // 最多可上传几个文件，默认为 100
            maxNumberOfFiles: 10,
            // 选择文件时的类型限制，默认为 ['image/*'] 。如不想限制，则设置为 []
            allowedFileTypes: ['image/*'],
            // 自定义上传参数，例如传递验证的 token 等。参数会被添加到 formData 中，一起上传到服务端。
            // meta: {
            //     token: '370cc8475d5a40c9aa0bbc223a860c02',
            //     fileType: 'yyy'
            // },
            // 将 meta 拼接到 url 参数中，默认 false
            metaWithUrl: false,
            // 自定义增加 http  header
            headers: {
                token:"",
                Accept: 'application/json; charset=utf-8',
                //ContentType: "application/json; charset=utf-8"
            },
        
            // 跨域是否传递 cookie ，默认为 false
            withCredentials: false,
            // 超时时间，默认为 10 秒
            timeout: 120 * 1000, // 5 秒
              
            onBeforeUpload (file) {    // JS 语法

                
              console.log("onBeforeUpload" )
                // file 选中的文件，格式如 { key: file }
                return file

                // 可以 return
                // 1. return file 或者 new 一个 file ，接下来将上传
                // 2. return false ，不上传这个 file
            },
            customInsert:(res, insertFn) =>{                  // JS 语法
              // res 即服务端的返回结果
              if(res.code ===0){
                let url = res.data.filePath
                let alt = "TEWS"
                let href = ""
                insertFn(url, alt, href)
              }else{
                this.$message({
                showClose: true,
                message: res.message,
                type: 'error',
                duration: MESSAGE_DURATION
                }) 

              }
              // 从 res 中找到 url alt href ，然后插入图片    
            },
            // 上传进度的回调函数
              onProgress:(progress)=> {       // JS 语法
                // progress 是 0-100 的数字
                console.log('progress', progress)
              },

              // 单个文件上传成功之后
          
              onSuccess:(file, res)=> {
                  console.log(`${file.name} 上传成功`, res)
              },

              // 单个文件上传失败
              onFailed : (file, res)=>{
                this.$message({
                      showClose: true,
                      message: res,
                      type: 'error',
                      duration: MESSAGE_DURATION
                  }) 
              },

              // 上传错误，或者触发 timeout 超时
              onError:(file, err, res)=> { 
                this.$message({
                      showClose: true,
                      message: err.message,
                      type: 'error',
                      duration: MESSAGE_DURATION
                  }) 
              },
            }
          },
          placeholder: '请输入内容...'
        },
        mode: 'default' // or 'simple'
      }
    }
  },
  methods : {
    onCreated(editor) {
      this.wangEditor.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
    },
    createNotice(){
      let content = this.wangEditor.editor.getHtml();
      let dat = {
        id : this.searchFactor.id,
        type : "",
        content : content,
        theme : this.searchFactor.theme
      }
      let url = "/bc/exa/notice/update"
      let s = JSON.stringify(dat)  
      axios.post(url, s).then((response) => {
        if (response.data.code === 0){
          this.$message({
            showClose: true,
            message: '编辑通知公告成功',
            type: 'success',
            duration: MESSAGE_DURATION
          })
      
        } else {
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch((err)=> {
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
      })
    },
    noticeOneLoad(id){
      let url = "/bc/exa/notice/getNoticeInfo"
      let dat0 = {
        id: id
      }
      axios.post(url, dat0).then((response) => {
        if (response.data.code === 0) {
          if(response.data.data != null &&  response.data.data != ''){
            if(response.data.data.content  != null && response.data.data.content != '' ){
              this.wangEditor.html = response.data.data.content
            }
            this.searchFactor.theme = response.data.data.theme
          } else {
            this.$message({
                showClose: true,
                message: '未查询到通知信息！',
                type: 'info',
                duration: MESSAGE_DURATION
            })
          }
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
        }).catch((err)=>{
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            duration: MESSAGE_DURATION
        })
      });
    },
  },
  created () {
    //this.searchFactor.id = this.$route.query.id
    setTimeout(()=>{getToken(this.wangEditor.editorConfig.MENU_CONF.uploadImage.headers)},200)
    this.searchFactor.id = this.$route.params.id
    this.wangEditor.editorConfig.MENU_CONF.uploadImage.server = SERVICE_URL
    + "/bc/exa/notice/upload?fileArea=" + fileAreaType.CONTENT  
    +"&id=" + this.$route.params.id
    this.noticeOneLoad(this.searchFactor.id)
  },
  mounted() {
    // 模拟 ajax 请求，异步渲染编辑器
    setTimeout(() => {
        this.html = '<p>模拟 Ajax 异步设置内容 HTML</p>'
    }, 1500)
  },
  beforeDestroy() {
    const notice = this.wangeEditor.editor
    if (notice == null) {
      return
    }
    notice.destroy() // 组件销毁时，及时销毁编辑器
  },
  components: { Editor, Toolbar }
}
</script>

<style lang="less" scoped>
.el-card {
  height: 99%
}
.text {
  font-size: 14px;
  color: #000;
}

.notice-content-view {
  border: 3px solid #ccc;
  border-radius: 5px;
  padding: 0 10px;
  margin-top: 20px;
  overflow-x: auto;
}

.notice-content-view p,
.notice-content-view li {
  white-space: pre-wrap; /* 保留空格 */
}

.notice-content-view blockquote {
  border-left: 8px solid #d0e5f2;
  padding: 10px 10px;
  margin: 10px 0;
  background-color: #f1f1f1;
}

.notice-content-view code {
  font-family: monospace;
  background-color: #eee;
  padding: 3px;
  border-radius: 3px;
}
.notice-content-view pre>code {
  display: block;
  padding: 10px;
}

.notice-content-view table {
  border-collapse: collapse;
}
.notice-content-view td,
.notice-content-view th {
  border: 1px solid #ccc;
  min-width: 50px;
  height: 20px;
}
.notice-content-view th {
  background-color: #f1f1f1;
}

.notice-content-view ul,
.notice-content-view ol {
  padding-left: 20px;
}

.notice-content-view input[type="checkbox"] {
  margin-right: 5px;
}
.el-divider--horizontal{
  background-color: #3c25d5;
  height: 4px;
  margin: 1px 0 10px 0;
  width: 85%
}
/deep/ .el-input__inner {
  border: none; 
  background-color: rgba(255, 255, 255, 0);
  padding :0
}
</style>
    


// WEBPACK FOOTER //
// src/pc_pages/pc_ctr_component/pc_ctr_notice_edit.vue